import { Grid, GridProps } from '@mui/material'
import React, { ReactNode } from 'react'
import withCapabilities from '../../hoc/withCapabilities'

interface ExtendedGrid2Props extends GridProps {
  children: ReactNode
  spacing?: number | { mobile?: number; tablet?: number; desktop?: number }
}

const GridContainer: React.FC<ExtendedGrid2Props> = ({ children, spacing = { mobile: 2, tablet: 2, desktop: 2 }, ...props }) => {
  return (
    <Grid container size={{ mobile: 12 }} spacing={spacing} {...props}>
      {children}
    </Grid>
  )
}
export default withCapabilities(GridContainer)
